<template>
    <div>
        <div v-bind:class="ContentBlockBaseProps.Class" v-bind:style="ContentBlockBaseProps.Style">
            <div :class="BlockProps.Shadow? 'shadow-sm mb-3' : ''" :style="{'background-color' : BlockProps.BGColor + ' !important'}">
                <div class="container" v-bind:style="ContainerPadding" style="max-width:100% !important">
                    <div class="row">
                        <div class="col-12  mt-5 mb-5">
                            <omnieditor :iseditmode="iseditmode" editortype="tinymce" class="w-lg-65 text-center mx-auto" keyDown v-model="BlockProps.Content" tag-name="div" :init="EditorConfig" />
                        </div>
                    </div>
                    <div class="row text-center shadow-sm mx-lg-10 py-3">

                        <div class="col-md-5">
                            <label for="inputGroupMergeFullName" class="form-label fw-bold">Pickup Address or Location</label>
                            <div class="input-group-merge" style="height:100px;">
                                <div class="input-card input-card-sm">
                                    <div class="input-card-form">
                                        <input style="width:100%" v-model="StartAddress" type="text" class="form-control form-control-lg" placeholder="Pickup Street, City, State and Zip" aria-label="Pickup Street, City, State and Zip">
                                    </div>
                                </div>
                                <label v-if="StartError" class="small text-red blink fw-bold">{{StartError}}</label>
                            </div>
                        </div>

                        <div class="col-md-5">
                            <label for="inputGroupMergeFullName" class="form-label fw-bold">Delivery Address or Location</label>
                            <div class="input-group-merge">
                                <div class="input-card input-card-sm">
                                    <div class="input-card-form">
                                        <input v-model="EndAddress" type="text" class="form-control form-control-lg" placeholder="Delivery Street, City, State and Zip" aria-label="Delivery Street, City, State and Zip">
                                    </div>
                                </div>
                                <label v-if="EndError" class="small text-red blink fw-bold">{{EndError}}</label>
                            </div>
                        </div>

                        <div class="col-md-2 text-center">
                            <div class="input-group-merge">
                                <div class="d-grid gap-2 d-md-block">
                                    <button v-bind:disabled="LoadingEstimate" v-on:click="CheckServiceArea" type="button" class="btn btn-primary btn-lg mt-3 btn-block">
                                        <span v-if="!LoadingEstimate">Check!</span>
                                        <div v-if="LoadingEstimate" class="spinner-border spinner-border-sm" role="status">
                                        </div>
                                    </button>
                                </div>

                            </div>


                        </div>

                    </div>

                </div>
            </div>
        </div>

        <div v-if="iseditmode" style="z-index:300" class="modal" :id="'editor' + BlockProps.UId" tabindex="-1" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Options</h5>
                    </div>
                    <div class="modal-body">
                        <hr style="margin: 0px; margin-bottom:10px;" />
                        <propertybaseeditors :blockprops="BlockProps" :additionalcfg="AdditionalCfg"></propertybaseeditors>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal">Done</button>
                        <!--<button type="button" class="btn btn-sm btn-primary">Save changes</button>-->
                    </div>
                </div>
            </div>
        </div>

        <div id="MessageModal" style="z-index:300" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="Modal Message" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title h4" id="mySmallModalLabel" v-html="ModalTitle"></h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">

                        <div class="row mb-5 text-center justify-content-center">
                            <div class="col-md-6 text-center justify-content-center">
                                <div class="d-grid gap-2">
                                    <a class="btn btn-success shadow btn-block btn-pointer" href="#">Get Standard Delivery For ${{MapCostStandard.toFixed(2)}} </a>
                                </div>
                            </div>
                            <div v-if="CourierConfig.offerExpressDelivery" class="col-md-6 text-center justify-content-center mt-3 mt-sm-0">
                                <div class="d-grid gap-2">
                                    <a class="btn btn-primary shadow btn-block btn-pointer" href="#">Get Express Delivery For ${{MapCostExpress.toFixed(2)}} </a>
                                </div>

                            </div>
                        </div>
                        <div class="row ">
                            <div class="col-md-12">
                                <div class="border-1 shadow">
                                    
                                    <iframe style="border:0;width:100%;height:400px"
                                            loading="lazy"
                                            allowfullscreen
                                            referrerpolicy="no-referrer-when-downgrade"
                                            :src="DirectionMapSrc">
                                    </iframe>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import EventHub from '/src/Util/EventHub.js';
    import ContentBlockBase from '/src/components/ContentCreator/ContentBlockBase.vue'
    import { computed, ref, nextTick } from 'vue'
    import axios from '/src/components/NovaAxios.js';
    import { toast } from 'vue3-toastify';

    export default {
        inheritAttrs: false,
        name: 'FeatureSingle',
        mixins: [ContentBlockBase],
        props: ['courierconfig'],
        components: {
        },
        computed:
        {
            CourierConfig: function () {
                var x = this.Store.TenantConfig;
                if (this.courierconfig) {
                    return this.courierconfig
                }

                if (this.Store && this.Store.TenantConfig && this.Store.TenantConfig.serviceConfigCourier) {
                    return this.Store.TenantConfig.serviceConfigCourier;
                }
            }
        },
        data() {
            return {  
                AdditionalCfg: 'https://admin.notarylaunchpad.com/home/sitesettings#CourierSettings',
                StartError: '',
                EndError: '',
                ModalObj: {},
                MapCostStandard: 0,
                StandardMsg: '',
                MapCostExpress: 0,
                ExpressMsg: '',
                ModalTitle: '',
                StartAddress: '',
                EndAddress: '',
                DirectionMapSrc: '',
                LoadingEstimate: false,
            };
        },
        methods:
        {
            ShowModal: function (title) {
                this.ModalTitle = title;
                this.ModalObj.show();
            },
            IsNumberCheck: function (s) {
                return /\d/.test(s);
            },
                               
            CheckServiceArea: async function () {                
                this.LoadingEstimate = true;
                EventHub.$emit("PageLoading", true);
                this.StartError = '';
                this.EndError = '';

                if (!this.StartAddress) {
                    this.StartError = "Pick-up address can't be blank.";
                }

                if (!this.EndAddress) {
                    this.EndError = "Delivery address can't be blank.";
                }

                if (!this.StartAddress || !this.EndAddress) {
                    toast.error("Both start and end addresses must be filled in.");
                    this.LoadingEstimate = false;
                    EventHub.$emit("PageLoading", false);
                    return;
                }

                    var that = this;
                    var token = document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value;
                    
                axios.postForm('/API/GetCourierDeliveryServiceEstimate', { startaddress: this.StartAddress, endaddress: this.EndAddress}, {
                        cache: false,
                        headers: {
                            'RequestVerificationToken': token
                        }
                }).then(function (response) {
                        that.LoadingEstimate = false;
                        EventHub.$emit("PageLoading", false);

                        if (response.data.success) {
                            that.DirectionMapSrc = response.data.directionmapsrc;

                            that.MapCostStandard = response.data.standardcost;
                            that.StandardMsg = response.data.standardmsg;

                            that.MapCostExpress = response.data.expresscost;
                            that.ExpressMsg = response.data.expressmsg;

                            that.MapDistance = response.data.mapdistance;

                            that.ModalMessage = "Your Addresses Are Within The Available Service Area";
                            that.ShowModal("<span style='color:green'>Service Estimate</span> - Distance " + that.MapDistance);
                        }
                        else {
                            that.StartError = response.data.starterror;
                            that.EndError = response.data.enderror;
                            toast.error(response.data.msg);
                        }
                    }).catch(function (error) {
                        EventHub.$emit("PageLoading", false);
                        toast.error("There was an error. Please refresh the page and try again.");
                        that.LoadingEstimate = false;
                    });
               
            },

            IsNumber: function (evt) {
                if (!this.IsNumberCheck(evt.key)) {
                    return evt.preventDefault();
                }
            },
            OnSlideImageUploaded: function (args) {
                if (args.success)
                {
                    if (this.BlockProps[args.idx] && args.url){
                        this.BlockProps[args.idx] = args.url;                    
                    }
                }
                
                this.EditProperties();
            },
            EditProperties: function () {
                var id = '#editor' + this.BlockProps.UId;
                var modalEl = document.querySelector(id);
                if (modalEl == null) {
                    return;
                }
                var modal = bootstrap.Modal.getOrCreateInstance(modalEl); // Returns a Bootstrap modal instance
                modal.show();
            },
            UploadNewSlideBackground: function(idx){
                this.HideEditProperties();
                var args = {};  

                var imgProp = 'Img' + idx;
                args.ExistingFileURL = this.BlockProps[imgProp];
                args.CompleteCallback = "OnSlideImageUploaded-" + this.BlockProps.UId;
                args.CompleteCallbackData = { MaxSize: 1024 * 75, idx: imgProp, url: ''}; // this will be sent back in the callback
                args.Prompt = `Image`;
                EventHub.$emit('UploadNewAssetBlockConfig', args);
            }
        },

        setup(props, context)
        {             
            return {} // anything returned here will be available for the rest of the component
        },
        created()
        {           
            EventHub.$on('OnSlideImageUploaded-' + this.BlockProps.UId, this.OnSlideImageUploaded);      
        },
        beforeUnmount()
        {
            EventHub.$off('OnSlideImageUploaded-' + this.BlockProps.UId, this.OnSlideImageUploaded);      
        },
        mounted() {
            this.ModalObj = new bootstrap.Modal(document.getElementById('MessageModal'))

            nextTick().then(() => {
      
            });
          
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

    #map {
        max-height: calc(100vh - 200px);
    }

    .blink {
        animation-name: blink;
        animation-duration: 1s;
        animation-iteration-count: 3;
    }

    @keyframes blink {
        0% {
            color: red
        }

        50% {
            color: rgba(0,0,0,0);
        }

        100% {
            color: red;
        }
    }

</style>

